import { render, staticRenderFns } from "./WeeklyQuestPanel.vue?vue&type=template&id=6952e879&"
import script from "./WeeklyQuestPanel.vue?vue&type=script&lang=ts&"
export * from "./WeeklyQuestPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports